import { useEffect } from "react"
import { useHistory, useLocation, withRouter } from "react-router"
import ChatOverviewList from "./ChatListOverview"
import 'react-circular-progressbar/dist/styles.css';
import { rootStore } from "../StApp";
import { BottomNavBar } from "../components/BottomNavBar";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { bottomNavLabels } from "../stores/UIStore";
import IMChatOverview from "./IMChatOverview";
import { ANONYMOUS } from "../models/constants";


export const TopAppBar = observer(() => {

    const history = useHistory()
    let location = useLocation<Location>()

    function logout() {

        rootStore.logout()
        history.push('/stapp/logout')
        //history.push('/')

    }

    function navToMyProfile() {
        if(rootStore.mainStore.userName == ANONYMOUS)
         return
        history.push('/stapp/profile')
    }

    return (<div className='nav-bar' style={{ display: rootStore.uiStore.appBarVisible ? 'flex' : 'none' }} >
        <h4>SayToMe</h4>
        <h3>{bottomNavLabels[rootStore.uiStore.bottomNavIndex]}</h3>
        <div className='flex-row center-align'>
            <span className="material-icons-outlined" 
            style={{fontSize: 30, cursor: 'pointer'}} 
            onClick={()=>history.push('/stapp/createInvite') } >
                email
            </span>
            <h4 style={{
                marginRight: 5,
                marginLeft: 5,
                cursor: 'pointer'
            }} onClick={navToMyProfile}>{rootStore.mainStore.userName}</h4>
            <p onClick={logout} className='material-icons-outlined' style={{cursor: 'pointer'}} >logout</p>
        </div>
    </div>);
})


const Home = () => {



    return (
        <div style={{ position: 'relative', height: '100%' }} >
            <TopAppBar></TopAppBar>
            {/* <ChatOverviewList /> */}


            <div className='st-app-wrapper' >
                <div className='st-app' >
                    {/* A <Switch> looks through its children <Route>s and
                      renders the first one that matches the current URL. */}
                    <Switch>
                        <Route path="/vnotes">
                            <ChatOverviewList />
                        </Route>
                        <Route path="/imchats">
                            <IMChatOverview />
                        </Route>
                        <Route>
                            <ChatOverviewList />
                        </Route>
                    </Switch>
                </div>
            </div>





        </div>
    )
}

export const LoggedHome = Home